<ng-content select="nav-menu"></ng-content>
<div class="capra-header-left">
  <capra-logo-button *ngIf="!navOpen"
    data-test="capra-header-nav-toggle"
    [hamburgerState]="showHamburger ? 'collapsed' : undefined"
    (clicked)="navToggleClick.emit()"
  ></capra-logo-button>
  <div class="capra-header-avatar">
    <ng-content select="[capra-header-avatar]"></ng-content>
  </div>
  <h2 *ngIf="text; else detailsTemplate"
    class="capra-header-text"
    data-test="capra-header-text"
  >
    {{ text }}
  </h2>
  <ng-template #detailsTemplate>
    <div class="capra-header-details"
      data-test="capra-header-details"
    >
      <ng-content select="[capra-header-details]"></ng-content>
    </div>
  </ng-template>
</div>

<div class="capra-header-right"
  data-test="capra-header-right"
>
  <ng-content select="[capra-header-right]"></ng-content>
</div>
